import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ContentViewService } from 'src/app/shared/content-views.service';
import { PendoService } from 'src/app/shared/pendo.service';

export interface IframeDialogData {
  title: string;
  url: string;
  backgroundColor: string;
}

export interface IframeMessage {
  action: 'track' | 'close';
  label: string;
  metadata?: {
    [key: string]: any;
  };
}

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IframeDialogComponent implements OnInit {
  @ViewChild('modalContents', { static: true })
  modalContents: ElementRef<HTMLDivElement>;

  title: string;
  url: SafeResourceUrl;
  abortController: AbortController;

  constructor(
    private dialogRef: MatDialogRef<IframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: IframeDialogData,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private pendoService: PendoService,
    private contentViewsService: ContentViewService,
  ) {}

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent<IframeMessage>) {
    switch (event.data.action) {
      case 'close':
        this.dialogRef.close(event.data);
        break;

      case 'track':
        this.pendoService.track(event.data.label, {
          ...event.data.metadata,
          platform: this.contentViewsService.getProductType(),
        });
        break;
    }
  }

  ngOnInit(): void {
    this.title = this.data.title;
    this.url = this.data.url ? this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url) : '';
    this.renderer.setStyle(
      this.modalContents.nativeElement,
      'background-color',
      this.data.backgroundColor || '#ffffff',
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
